;
define("item_relations_related_item.tpl", function(){});

